import type { Key, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { CheckoutHeader } from '@repo/domain-kit/invoices';
import { IconCertifiedFilled } from '@repo/monochrome-icons';
import styles from './checkout-success.module.css';

interface CheckoutSuccessProps {
  amount?: string;
  organizationName: string;
  invoiceNumber?: string;
  status: 'open' | 'paid';
  isClientPortalEnabled?: boolean;
  locales: { id: string; label: string }[];
  selectedLocale: string;
  onLocaleSelectionChange: (locale: Key) => void;
  children?: ReactNode;
}

export function CheckoutSuccess({
  amount,
  organizationName,
  invoiceNumber,
  status,
  locales,
  isClientPortalEnabled,
  selectedLocale,
  onLocaleSelectionChange,
  children,
}: CheckoutSuccessProps): ReactNode {
  return (
    <div className={styles.container} data-test-checkout-success>
      <div>
        <CheckoutHeader
          amount={amount}
          invoiceNumber={invoiceNumber}
          isClientPortalEnabled={isClientPortalEnabled}
          locales={locales}
          onLocaleSelectionChange={onLocaleSelectionChange}
          organizationName={organizationName}
          selectedLocale={selectedLocale}
          status={status}
        />
        {children}
      </div>
      <div className={styles.content}>
        <IconCertifiedFilled aria-hidden="true" className={styles.successIcon} />
        <h2 className="title-2" data-test-checkout-success-title>
          <FormattedMessage id="invoice.success.title" />
        </h2>
        <div className="body-2" data-test-checkout-success-subtitle>
          <FormattedMessage id="invoice.success.subtitle" />
        </div>
      </div>
    </div>
  );
}
